import { FlexColumn, FlexRowCenter } from "designSystem/index";
import React, { FunctionComponent } from "react";
import TableChartOptions from "../../csi/middleware/customView/options/TableChartOptions";
import TablePrintOptions from "../../csi/middleware/customView/options/TablePrintOptions";
import TableViewOptions from "../../csi/middleware/customView/options/TableViewOptions";
import TimelineViewOptions from "./TimelineViewOptions";

const TimelineOptionsTab: FunctionComponent = function TimelineOptionsTab() {
	return (
		<FlexRowCenter>
			<FlexColumn 
				data-csi-automation="TimelineOptionsTab"
				width="100%"
			>
				<TimelineViewOptions />
				<TableViewOptions />
				<TableChartOptions />
				<TablePrintOptions />
			</FlexColumn>
		</FlexRowCenter>
	);
};

export = TimelineOptionsTab